import { WebsitesApi } from 'src/filerd-client';

import { axiosInstance } from 'src/utils/axios';

export const filerdApi = WebsitesApi({}, '', axiosInstance);
